import { render, staticRenderFns } from "./accounting-report-sale-table.vue?vue&type=template&id=3a1a5b45&scoped=true&"
import script from "./accounting-report-sale-table.vue?vue&type=script&lang=ts&"
export * from "./accounting-report-sale-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a5b45",
  null
  
)

export default component.exports